import Products from '../components/Products'

export default Products;